'use strict';

document.addEventListener("DOMContentLoaded", function () {
   if ("IntersectionObserver" in window) {

      // 1. Progressive Blur Lazy Loading (Silky smooth blur-up transition)
      const lazyBlurPictures = document.querySelectorAll('picture.lazy-blur');
      if (lazyBlurPictures.length > 0) {
         const triggerBlurLoad = (picture) => {
            const img = picture.querySelector('img.lazy-img-blur');
            const sources = picture.querySelectorAll('source');

            sources.forEach(source => {
               if (source.dataset.srcset) {
                  source.srcset = source.dataset.srcset;
               }
            });

            if (img) {
               const onLoaded = () => {
                  requestAnimationFrame(() => {
                     picture.classList.add('loaded');
                     picture.classList.remove('lazy--styles');
                  });
               };

               if (img.dataset.srcset) {
                  img.srcset = img.dataset.srcset;
               }
               if (img.dataset.src) {
                  img.src = img.dataset.src;
               }

               if (img.complete && img.naturalWidth > 0) {
                  onLoaded();
               } else if ('decode' in img) {
                  img.decode().then(onLoaded).catch(() => {
                     img.addEventListener('load', onLoaded, { once: true });
                     img.addEventListener('error', onLoaded, { once: true });
                  });
               } else {
                  img.addEventListener('load', onLoaded, { once: true });
                  img.addEventListener('error', onLoaded, { once: true });
               }
            } else {
               picture.classList.add('loaded');
            }
         };

         const lazyBlurObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
               if (entry.isIntersecting) {
                  triggerBlurLoad(entry.target);
                  observer.unobserve(entry.target);
               }
            });
         }, {
            rootMargin: "150px 0px",
            threshold: 0.01
         });

         lazyBlurPictures.forEach(picture => {
            lazyBlurObserver.observe(picture);
         });
      }

      // 2. Standard Picture Lazy Loading
      const lazyPictures = document.querySelectorAll('picture.lazy');
      if (lazyPictures.length > 0) {
         const lazyPictureObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
               if (entry.isIntersecting) {
                  const lazyPicture = entry.target;
                  const sources = lazyPicture.querySelectorAll('source');
                  const img = lazyPicture.querySelector('img');

                  sources.forEach(source => {
                     if (source.dataset.srcset) {
                        source.srcset = source.dataset.srcset;
                     }
                  });

                  if (img) {
                     const onLoaded = () => {
                        requestAnimationFrame(() => {
                           lazyPicture.classList.add('animation-fade-in', 'loaded');
                           lazyPicture.classList.remove("lazy--styles");
                        });
                     };

                     if (img.dataset.srcset) {
                        img.srcset = img.dataset.srcset;
                     }
                     if (img.dataset.src) {
                        img.src = img.dataset.src;
                     }

                     if (img.complete && img.naturalWidth > 0) {
                        onLoaded();
                     } else {
                        img.addEventListener('load', onLoaded, { once: true });
                     }
                  } else {
                     lazyPicture.classList.add('animation-fade-in', 'loaded');
                  }

                  observer.unobserve(lazyPicture);
               }
            });
         }, {
            rootMargin: "150px 0px",
            threshold: 0.01
         });

         lazyPictures.forEach(lazyPic => {
            lazyPictureObserver.observe(lazyPic);
         });
      }

      // 3. Standalone Image Lazy Loading
      const lazyImages = document.querySelectorAll('img.lazy');
      if (lazyImages.length > 0) {
         const lazyImageObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
               if (entry.isIntersecting) {
                  const lazyImage = entry.target;
                  const onLoaded = () => {
                     requestAnimationFrame(() => {
                        lazyImage.classList.add('animation-fade-in', 'loaded');
                        lazyImage.classList.remove("lazy--styles");
                     });
                  };

                  if (lazyImage.dataset.srcset) {
                     lazyImage.srcset = lazyImage.dataset.srcset;
                  }
                  if (lazyImage.dataset.src) {
                     lazyImage.src = lazyImage.dataset.src;
                  }

                  if (lazyImage.complete && lazyImage.naturalWidth > 0) {
                     onLoaded();
                  } else {
                     lazyImage.addEventListener('load', onLoaded, { once: true });
                  }

                  observer.unobserve(lazyImage);
               }
            });
         }, {
            rootMargin: "150px 0px",
            threshold: 0.01
         });

         lazyImages.forEach(lazyImage => {
            lazyImageObserver.observe(lazyImage);
         });
      }

      // 4. Video Lazy Loading
      const lazyVideos = document.querySelectorAll('video.lazy');
      if (lazyVideos.length > 0) {
         const lazyVideoObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
               if (entry.isIntersecting) {
                  const video = entry.target;
                  const sources = video.querySelectorAll('source');
                  sources.forEach(source => {
                     if (source.dataset.src) {
                        source.src = source.dataset.src;
                     }
                  });

                  if (video.dataset.poster) {
                     video.poster = video.dataset.poster;
                  }

                  video.load();
                  video.classList.remove("lazy--styles");
                  video.classList.add('animation-fade-in');
                  observer.unobserve(video);
               }
            });
         }, {
            rootMargin: "200px 0px",
            threshold: 0.01
         });

         lazyVideos.forEach(lazyVideo => {
            lazyVideoObserver.observe(lazyVideo);
         });
      }

      // 5. Video Poster Lazy Loading
      const lazyPosters = document.querySelectorAll('video.lazy-poster');
      if (lazyPosters.length > 0) {
         const lazyPosterObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
               if (entry.isIntersecting) {
                  const video = entry.target;
                  if (video.dataset.poster) {
                     video.poster = video.dataset.poster;
                  }
                  video.load();
                  video.classList.remove("lazy--styles");
                  video.classList.add('animation-fade-in');
                  observer.unobserve(video);
               }
            });
         }, {
            rootMargin: "200px 0px",
            threshold: 0.01
         });

         lazyPosters.forEach(lazyPoster => {
            lazyPosterObserver.observe(lazyPoster);
         });
      }

      // 6. Background Lazy Loading
      const lazyBackgrounds = document.querySelectorAll('.lazy-bg');
      if (lazyBackgrounds.length > 0) {
         const lazyBackgroundObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
               if (entry.isIntersecting) {
                  const lazyBg = entry.target;
                  if (lazyBg.getAttribute('data-bg')) {
                     lazyBg.style.backgroundImage = lazyBg.getAttribute('data-bg');
                  }
                  lazyBg.classList.add('animation-fade-in');
                  lazyBg.classList.remove("lazy--styles");
                  observer.unobserve(lazyBg);
               }
            });
         }, {
            rootMargin: "150px 0px",
            threshold: 0.01
         });

         lazyBackgrounds.forEach(lazyBg => {
            lazyBackgroundObserver.observe(lazyBg);
         });
      }

   } else {
      // Fallback if IntersectionObserver is not supported
      document.querySelectorAll('picture.lazy, picture.lazy-blur').forEach(picture => {
         picture.querySelectorAll('source').forEach(s => {
            if (s.dataset.srcset) s.srcset = s.dataset.srcset;
         });
         const img = picture.querySelector('img');
         if (img && img.dataset.srcset) img.srcset = img.dataset.srcset;
         picture.classList.add('loaded');
      });
      document.querySelectorAll('img.lazy').forEach(img => {
         if (img.dataset.src) img.src = img.dataset.src;
         if (img.dataset.srcset) img.srcset = img.dataset.srcset;
         img.classList.add('loaded');
      });
   }
});